// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-m__footer__GnfHd","a":"styles-m__a__1bWNZ","footer-links":"styles-m__footer-links__uGV1d"};